import React, { Component } from "react"
import { Link } from "react-router-dom"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from "lodash"
import ReactTable from "react-table"
import moment from "moment"
//! Maybe dead

class Builder extends Component {
    constructor(props) {
        super(props)
        this.id = +this.props.match.params.id
        this.state = {
            sales: 0,
            traffic: 0,
            cancels: 0,
            closings: 0,
            numLots: 0,
            closingPercentage: 0,
            averagePrice: 0,
            ppSqft: 0,
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.payload.sales.current !== this.props.payload.sales.current
        ) {
            this.buildData()
        }
    }

    componentDidMount() {
        this.buildData()
    }

    buildData = () => {
        var ret = {
            sales: 0,
            traffic: 0,
            cancels: 0,
            closings: 0,
            numLots: 0,
            closingPercentage: 0,
            averagePrice: 0,
            ppSqft: 0,
        }
        let b = _.find(this.props.payload.public.builders.children, {
            id: this.id,
        })
        if (b) {
            // Num Lots
            ret.numAvailLots = b.numAvailLots ? b.numAvailLots : 0
            ret.numAvailHomes = b.numAvailHomes ? b.numAvailHomes : 0
        }
        // Num Sales
        _.forEach(this.props.payload.sales.current, v => {
            if (v.builder == this.id) {
                ret.sales++
            }
        })

        // Num Traffic
        _.forEach(this.props.payload.traffic.current, v => {
            if (v.builder == this.id) {
                ret.traffic++
            }
        })

        // Num cancels
        _.forEach(this.props.payload.cancels.current, v => {
            if (v.builder == this.id) {
                ret.cancels++
            }
        })

        // Num Closings
        _.forEach(this.props.payload.closings.current, v => {
            if (v.builder == this.id) {
                ret.closings++
            }
        })

        // Average Sale Price
        _.forEach(this.props.payload.sales.current, v => {
            if (v.builder == this.id) {
                ret.averagePrice += v.price
            }
        })
        ret.averagePrice = ret.averagePrice
            ? Math.round(ret.averagePrice / ret.sales).toLocaleString()
            : 0

        // Average PPSQFT
        _.forEach(this.props.payload.sales.current, v => {
            if (v.builder == this.id) {
                var sale = v.price / v.sqft
                ret.ppSqft += sale
            }
        })
        ret.ppSqft = ret.ppSqft
            ? Math.round(ret.ppSqft / ret.sales).toLocaleString()
            : 0

        this.setState(ret)
    }

    buildSalesTable = () => {
        var ret = []
        this.props.payload.sales.current.forEach(r => {
            if (r.builder == this.id) {
                var v = {}
                let sp = _.find(
                    this.props.payload.public.salespeople,
                    { id: r.salesperson }
                )
                v.price = `$${r.price.toLocaleString()}`
                v.salesperson = `${sp.first_name} ${
                    sp.last_name
                }`
                v.address = <Link to={`/sales/${r.id}`}>{r.address}</Link>
                v.date = r.sale_date ? r.sale_date : r.addedDate
                ret.push(v)
            }
        })
        ret = _.sortBy(ret, "date").reverse()
        return ret
    }

    buildTrafficTable = () => {
        var ret = []
        this.props.payload.traffic.current.forEach(r => {
            if (r.builder == this.id) {
                var v = {}
                v.salesperson = this.props.payload.salespeople[
                    r.salesperson
                ].title
                v.source = this.props.payload.trafficSources[r.source]
                v.neighborhood = this.props.payload.neighborhoods[
                    r.neighborhood
                ]
                v.date = r.sale_date ? r.sale_date : r.addedDate
                ret.push(v)
            }
        })
        ret = _.sortBy(ret, "date").reverse()
        return ret
    }

    buildCancelsTable = () => {
        var ret = []
        this.props.payload.cancels.current.forEach(r => {
            if (r.builder == this.id) {
                var v = {}
                let sp = _.find(
                    this.props.payload.public.salespeople,
                    { id: r.salesperson }
                )
                v.salesperson = `${sp.first_name} ${
                    sp.last_name
                }`
                v.address = <Link to={`/sales/${r.id}`}>{r.address}</Link>
                v.date = r.cancel_date
                v.reason = r.cancel_reason
                ret.push(v)
            }
        })
        ret = _.sortBy(ret, "date").reverse()
        return ret
    }

    buildClosingsTable = () => {
        var ret = []
        this.props.payload.closings.current.forEach(r => {
            if (r.builder == this.id) {
                var v = {}
                let sp = _.find(
                    this.props.payload.public.salespeople,
                    { id: r.salesperson }
                )
                v.closed_price = `$${r.closing_price.toLocaleString()}`
                v.sale_price = `$${r.price.toLocaleString()}`
                v.salesperson = `${sp.first_name} ${
                    sp.last_name
                }`
                v.address = <Link to={`/sales/${r.id}`}>{r.address}</Link>
                v.date = r.closing_date
                ret.push(v)
            }
        })
        ret = _.sortBy(ret, "date").reverse()
        return ret
    }

    render() {
        if (this.props.payloadStatus) {
            const salesColumns = [
                {
                    Header: "Sales Person",
                    accessor: "salesperson",
                },
                {
                    Header: "Address",
                    accessor: "address",
                },
                {
                    Header: "Price",
                    accessor: "price",
                },
                {
                    Header: "Date",
                    accessor: "date",
                    Cell: props => moment.unix(props.value).format("M/D/YY"),
                    sort: "desc",
                },
            ]

            const closingColumns = [
                {
                    Header: "Sales Person",
                    accessor: "salesperson",
                },
                {
                    Header: "Address",
                    accessor: "address",
                },
                {
                    Header: "Closing Price",
                    accessor: "closed_price",
                },
                {
                    Header: "Sale Price",
                    accessor: "sale_price",
                },
                {
                    Header: "Date",
                    accessor: "date",
                    Cell: props => moment.unix(props.value).format("M/D/YY"),
                    sort: "desc",
                },
            ]
            const cancelsColumn = [
                {
                    Header: "Sales Person",
                    accessor: "salesperson",
                },
                {
                    Header: "Address",
                    accessor: "address",
                },
                {
                    Header: "Reason",
                    accessor: "reason",
                },
                {
                    Header: "Date",
                    accessor: "date",
                    Cell: props => moment.unix(props.value).format("M/D/YY"),
                    sort: "desc",
                },
            ]
            let builder = _.find(this.props.payload.public.builders.children, {id: this.id})
            return (
				<div className="builder">
					<Title title={builder.name} />
					<div className="content">
						<ul className="builder__list">
							<li className="builder__item">
								<span>{this.state.sales}</span>
								<br />
								<span>Sales</span>
							</li>
							<li className="builder__item">
								<span>{this.state.traffic}</span>
								<br />
								<span>Traffic</span>
							</li>
							<li className="builder__item">
								<span>{this.state.cancels}</span>
								<br />
								<span>Cancels</span>
							</li>
							<li className="builder__item">
								<span>{this.state.closings}</span>
								<br />
								<span>Closings</span>
							</li>
							<li className="builder__item">
								<span>${this.state.averagePrice}</span>
								<br />
								<span>Average Sale Price</span>
							</li>
							<li className="builder__item">
								<span>${this.state.ppSqft}</span>
								<br />
								<span>Average PP/SQFT</span>
							</li>
							<li className="builder__item">
								<span>{this.state.numAvailLots}</span>
								<br />
								<span>
									Number of Lots Available
									<sup
										className="tooltippy tooltippy--right"
										data-tooltippy="This value indicates a date range of all-time.">
										*
									</sup>
								</span>
							</li>
							<li className="builder__item">
								<span>
									{this.state.numAvailHomes}
									<sup
										className="tooltippy tooltippy--right"
										data-tooltippy="This value indicates a date range of all-time.">
										*
									</sup>
								</span>
								<br />
								<span>Number of Homes Available</span>
							</li>
						</ul>
						<h2>Sales</h2>
						<ReactTable
							data={this.buildSalesTable()}
							columns={salesColumns}
							loadingText=""
							defaultPageSize={10}
						/>
						<h2>Closings</h2>
						<ReactTable
							loadingText=""
							data={this.buildClosingsTable()}
							columns={closingColumns}
							defaultPageSize={10}
						/>
						<h2>Cancels</h2>
						<ReactTable
							loadingText=""
							data={this.buildCancelsTable()}
							columns={cancelsColumn}
							defaultPageSize={10}
						/>
					</div>
				</div>
			)
        } else {
            return ""
        }
    }
}

function mapStateToProps(state) {
    return {
        currentDates: state.currentDates,
        compareDates: state.compareDates,
        payload: state.payload,
        payloadStatus: state.payloadStatus,
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(Builder)
